import { AvatarGroup } from '@material-ui/lab';
import styled from 'styled-components';
export const StyledAvatarGroup = styled(AvatarGroup) `
    div {
        height: ${(props) => (props.$size ? props.$size : '40px')};
        width: ${(props) => (props.$size ? props.$size : '40px')};
    }

    div:last-of-type {
        height: ${(props) => (props.$size ? props.$size : '40px')};
        width: ${(props) => (props.$size ? props.$size : '40px')};
        background-color: transparent;
        border: 1px solid ${(props) => props.theme.colors.border};
        color: ${(props) => props.theme.colors.text};
    }
`;
//# sourceMappingURL=Avatar.styles.js.map